//=====================================================
//　お名前テキストボックス
//=====================================================

import { useFormContext } from "react-hook-form";
import { InputTag } from "../utils/ConstCommon";
import { getMsg, ConstMsg } from "../utils/ConstMsg";
import { InputTextBase } from "./InputTextBase";
import { LblInput } from "./LblInput";
import { ValidErrMsgInline } from "./ValidErrMsgInline";

interface IFProps {
    nameLastName: string,
    nameFirstName: string
}

const FORM_TITLE = "お名前";

export function TxtName(props: IFProps) {
    
    const cf = useFormContext();

    //バリデーション
    const validations = {
        required: getMsg(ConstMsg.EG0040001, [FORM_TITLE]),
        pattern: {value: /^[\u3040-\u309F]+$/, message: getMsg(ConstMsg.EG0040002, [FORM_TITLE])},
        maxLength: {value: 40, message: getMsg(ConstMsg.EG0040003, [FORM_TITLE, "40"])}
    }

    return (
        <div className="input-box">
            <LblInput title={FORM_TITLE} tag={InputTag.Required} />
            <ValidErrMsgInline name={props.nameLastName}/>
            {!cf.formState.errors[props.nameLastName] && <ValidErrMsgInline name={props.nameFirstName}/>}
            <div className="input-supple-flex">
                <InputTextBase name={props.nameLastName} className="input-text-last-name" placeholder="例）よこはま" validations={validations}/>
                <InputTextBase name={props.nameFirstName} className="input-text-first-name" placeholder="例）たろう" validations={validations}/>
            </div>
            <div className="input-supple">
                <div className="input-supple-flex">
                    <div className="input-supple-name">姓</div>
                    <div className="input-supple-name">名</div>
                </div>
                <div>※全角ひらがなのみ</div>
            </div>
        </div>
    )

}